import React from "react";
import {Text} from "@chakra-ui/react";

export function TagPathText({ children }) {
    return (
        <Text fontSize="sm" color="gray.400">{children}</Text>
    )
}